export default "__VITE_ASSET__BXxRXMom__"